<template>
  <div class="animated fadeIn equipmentList bgV2">
    <b-row class="pt-17">
      <b-col md="12">
        <div class="boxShadow setBorderRadius pl-20 pr-20 heig-frame" v-bind:class="{'run-loading':loading.listing}">
          <b-row class="content mt-10">
            <b-col md="3">
              <div class="control pull-left pl-16 ">
                <div class="list innerControl">
                  <div class="custom-control custom-control-inline">
                    <b-form-checkbox type="checkbox" class="uniform" id="checkAll" v-model="allSelected" @input="toggleSelected">
                    </b-form-checkbox>
                  </div>
                  <span class="search" v-b-tooltip.hover title="Refresh" @click="refresh">
                    <img src="img/reLoad.png" alt="reload">
                  </span>
                  <span v-if="$checkRole($accessModule.master_priority_set, 'create')" class="search" @click="openModalAdd" v-b-tooltip.hover title="Create">
                    <img src="img/blankIcon.png" alt="blank">
                  </span>
                  <span class="search" v-if="selected.length > 0 && $checkRole($accessModule.master_priority_set, 'update')" v-b-tooltip.hover title="Delete" @click="$bvModal.show('modal-Remove')">
                    <img src="img/deleteIcon.png" alt="delete">
                  </span>
                </div>
                <b-modal :no-close-on-backdrop="true" id="modal-EditPrioritySet" :title="titleModal" hide-footer :centered="true" ref="modal-EditPrioritySet">
                  <b-form class="pb-20">
                      <b-row>
                        <b-col md="6">
                          <gofix-form-input label="Master Priority Set Name" v-model="selectedPrioritySet.priority_title"></gofix-form-input>
                        </b-col>
                      </b-row>
                      <hr/>
                    <gofix-form-input
                            label="priority name"
                            v-for="(option, index) in selectedPrioritySet && selectedPrioritySet.priority_options"
                            :key="index"
                            v-model="selectedPrioritySet.priority_options[index]">
                      <template #gofixInput:text:after-desc>
                        <b-button @click="deletePriorityRight(index)" class="deletePriorityRight">
                          <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.75 5.5H19.25" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M7.33203 5.50065V3.66732C7.33203 3.18109 7.52519 2.71477 7.869 2.37096C8.21282 2.02714 8.67913 1.83398 9.16537 1.83398H12.832C13.3183 1.83398 13.7846 2.02714 14.1284 2.37096C14.4722 2.71477 14.6654 3.18109 14.6654 3.66732V5.50065M17.4154 5.50065V18.334C17.4154 18.8202 17.2222 19.2865 16.8784 19.6303C16.5346 19.9742 16.0683 20.1673 15.582 20.1673H6.41536C5.92913 20.1673 5.46282 19.9742 5.119 19.6303C4.77519 19.2865 4.58203 18.8202 4.58203 18.334V5.50065H17.4154Z" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M9.16797 10.084V15.584" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M12.832 10.084V15.584" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </b-button>
                      </template>
                    </gofix-form-input>
                    <gofix-button label="+ add priority" @click="addProritySet" outline></gofix-button>
                  </b-form>
                  <b-button-group class="d-block text-right" v-if="$checkRole($accessModule.master_priority_set, 'update')">
                    <gofix-button label="SUBMIT" @click="updatePrioritySet" noBorder></gofix-button>
                  </b-button-group>
                </b-modal>
              </div>
              <b-modal :no-close-on-backdrop="true" id="modal-Remove" title="remove to user" hide-footer hide-header :centered="true" ref="modal-Remove">
                <div class="center">Are you sure you want to<br/>delete <strong>This Item</strong>?</div>
                <b-button-group class="btn-group">
                  <b-button class="custom-btn" @click="closeModalRemoveUser">No</b-button>
                  <b-button class="custom-btn" :disabled="isAction" @click="deletePriorityMasterSet">Yes</b-button>
                </b-button-group>
              </b-modal>
              <b-modal :no-close-on-backdrop="true" id="modal-RemoveAlert" title="remove to user" hide-footer hide-header :centered="true" ref="modal-RemoveAlert">
                <div class="center">Please select at least 1 line to delete!!!</div>
                <b-button-group class="d-block text-right">
                  <gofix-button label="SUBMIT" @click="closeModalRemoveAlert" noBorder></gofix-button>
                </b-button-group>
              </b-modal>
            </b-col>
            <b-col md="9">
              <div class="control">
                <Pagination :Items="this.prioritySetMasterList" v-model="pages"></Pagination>
                <div class="list innerControl  ml-2">
                  <span class="filter" v-on:click="filterActive" v-bind:class="[filterActive, activeClass ? 'active' : '']">
                    <div class="tooltip">Filter</div>
                    <svg width="21" height="13" viewBox="0 0 21 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.30512 13H12.7496V10.8333H8.30512V13ZM0.527344 0V2.16667H20.5273V0H0.527344ZM3.86068 7.58333H17.194V5.41667H3.86068V7.58333Z" fill="#999999"/>
                    </svg>
                  </span>
                  <span class="search">
                    <div class="tooltip">Setting</div>
                    <b-dropdown class="btn btnConfig" right>
                      <b-dropdown-item href="#">Import</b-dropdown-item>
                      <b-dropdown-item href="#">Export</b-dropdown-item>
                    </b-dropdown>
                  </span>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="filterOrg" v-bind:class="[filterActive, activeClass ? 'open' : '']">
            <b-col md="12" class="mt-20">
              <b-row>
                <b-col md="2">
                  <gofix-form-input label="Mastr Priority Set Title" v-model="pages.filter.priority_title" @change="searchMasterPriority"></gofix-form-input>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="rowOrg mt-25">
            <b-col md="12" v-for="(item, index) in prioritySetMasterList" :key="index">
              <div class="boxOrg min-height-90">
                <div class="title">
                  <div class="custom-control custom-checkbox custom-control-inline ml-26">
                    <input type="checkbox" :value="item.id" v-model="selected" class="custom-control-input" :id="'customInChk'+item.id">
                    <label class="custom-control-label" :for="'customInChk'+item.id"></label>
                  </div>
                  <div class="custom-name fix">
                    <strong>{{item.priority_title}}</strong>
                  </div>
                  <ul class="actions">
                    <li>
                      <button v-if="$checkRole($accessModule.master_priority_set, 'update')" @click="editItem(item)">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M17.2582 4.69276C17.5832 5.01776 17.5832 5.54276 17.2582 5.86776L15.7332 7.39276L12.6082 4.26776L14.1332 2.74276C14.2889 2.58672 14.5003 2.49902 14.7207 2.49902C14.9411 2.49902 15.1525 2.58672 15.3082 2.74276L17.2582 4.69276ZM2.5 17.0844V14.5511C2.5 14.4344 2.54167 14.3344 2.625 14.2511L11.7167 5.15943L14.8417 8.28442L5.74167 17.3761C5.66667 17.4594 5.55833 17.5011 5.45 17.5011H2.91667C2.68333 17.5011 2.5 17.3178 2.5 17.0844Z" fill="#999999"/>
                        </svg>
                      </button>
                    </li>
                  </ul>
                </div>
                <b-row class="content padding-5-15">
                  <b-col md="2" v-for="(priSet, i) in item && item.priority_options" :key="i">
                      <label>#{{i + 1}}</label>
                      <div class="info-right">{{priSet}}</div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script src="https://unpkg.com/vue@2.2.6"></script>
<script>
  import {mapGetters, mapActions} from 'vuex';
  export default {
    name: 'priority-set',
    components: {

    },
    data() {
      return {
        activeFilter:false,
        allSelected: false,
        selected: [],
        isAction: false,
        activeClass: false,
        nameTable: 'tableCSLA',
        options: ['Set 01', 'Set 02'],
        optionsSelected: 'Set 01',
        titleModal: 'Create Master Priority',
        selectedPrioritySet: {},
        loading: {
          listing: false,
        },
        pages: {
          limit: 100,
          page: 1,
          totalPage: 0,
          filter: {
            is_master: true
          }
        },
        items: [
          //
        ]
      }
    },
    watch: {
      selected: function(val) {
        if(this.prioritySetMasterList.length > val.length) {
          this.allSelected = false
          return
        }
        if(val.length > 0 && this.prioritySetMasterList.length == val.length) {
          this.allSelected = true
        }
      },
      "pages.limit": function (val) {
        if(this.pages.page === 1){
          this.reloadMasterPerioritySet();
        }else{
          this.pages.page = 1;
        }
      },
      "pages.page": function (val) {
        this.reloadMasterPerioritySet();
      },
    },

    mounted() {
      //
    },
    created(){
      this.reloadMasterPerioritySet();
    },
    computed: {
      ...mapGetters({
          UserLogin: "AuthController/user",
          prioritySetMasterList: 'v2PrioritySetController/prioritySetMasterList',
          prioritySetMasterTotal: 'v2PrioritySetController/prioritySetMasterTotal',
          ClientContractID: 'ContractController/ClientContractID'
      }),
    },
    methods: {
      toggleSelected (){
        if (this.allSelected) {
          this.selected = [];
          for (let i in this.prioritySetMasterList) {
            this.selected.push(this.prioritySetMasterList[i].id)
          }
          return
        }
        if(!this.allSelected && this.prioritySetMasterList.length == this.selected.length) {
          this.selected = []
        }
      },
      searchMasterPriority(){
        this.pages.page = 1;
        this.selected = [];
        this.loading.listing = true;
        this.reloadMasterPerioritySet();
      },
      refresh() {
        this.pages.filter = {is_master: true};
        this.pages.page = 1;
        this.allSelected = false;
        this.reloadMasterPerioritySet();

      },
      reloadMasterPerioritySet(){
        this.loading.listing = true;
        this.$store.dispatch("v2PrioritySetController/getPrioritySetMasterList", this.pages).then(response => {
            this.pages.totalPage =  Math.ceil(response.total/this.pages.limit);
            this.loading.listing = false;
        });
      },
      addProritySet(){
        this.selectedPrioritySet.priority_options.push("");
      },
      deletePriorityRight(index){
        this.selectedPrioritySet.priority_options.splice(index, 1)
      },
      updatePrioritySet(){
        if(this.selectedPrioritySet.id){
          this.$store.dispatch("v2PrioritySetController/updatePrioritySet", this.selectedPrioritySet
          ).then(data => {
            this.reloadMasterPerioritySet();
            this.$refs['modal-EditPrioritySet'].hide();
            this.selectedPrioritySet = {};
          })
        }else{
          this.$store.dispatch("v2PrioritySetController/createPrioritySet", this.selectedPrioritySet
          ).then(data => {
            this.reloadMasterPerioritySet();
            this.$refs['modal-EditPrioritySet'].hide();
            this.selectedPrioritySet = {};
          })
        }
      },
      openModalRemoveUser() {
       if(this.selected.length > 0) {
          this.$refs['modal-Remove'].show()
        } else {
          this.$refs['modal-RemoveAlert'].show()
        }
      },
      closeModalRemoveUser() {
        this.$refs['modal-Remove'].hide()
      },
      closeModalRemoveAlert() {
        this.$refs['modal-RemoveAlert'].hide()
      },
      deletePriorityMasterSet(){
        this.isAction = true;
        this.$store
            .dispatch("v2PrioritySetController/deletePriorityMasterSet", this.selected)
            .then(response => {
                this.isAction = false;
                this.selected = [];
                this.$refs["modal-Remove"].hide();
                this.reloadMasterPerioritySet();
            });
      },
      filterActive(){
        this.activeClass = !this.activeClass
      },
      openModalAdd (){
        this.selectedPrioritySet = { is_master: true, priority_title: "", priority_options: [] }
        if(this.ClientContractID && this.ClientContractID.id) {
          this.selectedPrioritySet.priority_title = this.ClientContractID.abbreviation + '-' + this.ClientContractID.id;
          this.selectedPrioritySet.set_name = this.ClientContractID.abbreviation + '-' + this.ClientContractID.id;
        }
        this.titleModal = 'Create Master Priority'
        this.$refs['modal-EditPrioritySet'].show()
      },
      filterActive(){
        this.activeClass = !this.activeClass
      },
      editItem(item) {
        this.titleModal = 'Edit Master Priority'
        this.$refs['modal-EditPrioritySet'].show();
        this.selectedPrioritySet = item
        this.selectedPrioritySet.is_master = true;
      }
    }
  }
</script>
